<template>
  <div class="shops-module d-flex align-items-center">

      <div class="main-shop-container">

<!--
        <router-link tag="div" :to="{name: 'payment',params: { id:0,type:'بازی های ساحلی و بادی',title:name,image:image,des:pack_des,price:price}}" class="beach-games-top">
-->


        <div class="shop-items d-flex flex-row justify-content-center mt-3">
          <router-link tag="div" :to="{name:'mall-single',params: {id:8,name:'مرکز خرید مروارید'}}" class="shop-item">
              <div class="shop-image"><img src="~@/assets/img/shops/mall5.png"></div>
              <p class="shop-desc">مرکز خرید مروارید</p>
          </router-link>
        </div>


        <div class="shop-items d-flex flex-row flex-row-reverse">
          <router-link tag="div" :to="{name:'mall-single',params: {id:3,name:'مرکز خرید پردیس 1 و 2'}}" class="shop-item">
            <div class="shop-image"><img src="~@/assets/img/shops/mall3.png"></div>
            <p class="shop-desc">مرکز خرید پردیس 1 و 2</p>
          </router-link>

          <router-link tag="div" :to="{name:'mall-single',params: {id:2,name:'مرکز خرید زیتون'}}" class="shop-item">
            <div class="shop-image"><img src="~@/assets/img/shops/mall2.png"></div>
            <p class="shop-desc">مرکز خرید زیتون</p>
          </router-link>
        </div>

        <div class="shop-items d-flex flex-row justify-content-end">
          <router-link tag="div" :to="{name:'mall-single',params: {id:10,name:'مرکز تجاری کیش'}}" class="shop-item">
            <div class="shop-image"><img src="~@/assets/img/shops/mall1.png"></div>
            <p class="shop-desc">مرکز تجاری کیش</p>
          </router-link>
        </div>

        <div class="shop-items flex-row-reverse d-flex flex-row justify-content-end">
          <router-link tag="div" :to="{name:'mall-single',params: {id:9,name:'رویا مال'}}" class="shop-item">
            <div class="shop-image"><img src="~@/assets/img/shops/mall6.png"></div>
            <p class="shop-desc">رویا مال</p>
          </router-link>

          <router-link tag="div" :to="{name:'mall-single',params: {id:5,name:'مرکز خرید دامون'}}" class="shop-item mr-2" style="margin-right: 10px;margin-left: 15px;">
            <div class="shop-image"><img src="~@/assets/img/shops/mall5.png"></div>
            <p class="shop-desc">مرکز خرید دامون</p>
          </router-link>
        </div>

        <div class="shop-items d-flex flex-row justify-content-center flex-row-reverse">

          <router-link tag="div" :to="{name:'mall-single',params: {id:11,name:'مرکز خرید پانیذ'}}" class="shop-item" style="margin-left: 5px; ">
            <div class="shop-image"><img src="~@/assets/img/shops/mall2.png"></div>
            <p class="shop-desc">مرکز خرید پانیذ</p>
          </router-link>

          <router-link tag="div" :to="{name:'mall-single',params: {id:7,name:'مرکز خرید سارینا'}}" class="shop-item">
            <div class="shop-image"><img src="~@/assets/img/shops/mall7.png"></div>
            <p class="shop-desc">مرکز خرید سارینا</p>
          </router-link>
        </div>

      </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      items: null,
    };
  },
  created() {
    //this.getShops();
  },
  methods: {
    async getShops() {
      let fd = new FormData();
      fd.append("flag","mall");
      fd.append("mid",8);

      const response = await this.$ApiServiceLayer.post("get_shops");
      console.log(response);
      if (response) {
        this.items = response;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shops-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/mainshopback.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  //padding: 10px;
  .main-shop-container{
    width: 100%;
    min-height: fit-content;
    background-image: url("~@/assets/img/bg/island_map2.png");
    background-position: center;
    background-size: 107%;
    background-repeat: no-repeat;
    //padding: 10px;
    .shop-items{
      .shop-item{
        img{
          width: 73px;
          height: 61px;
        }
        p{
          padding: 4px;
          background: #ffffffb5;
          border-radius: 8px;
          text-align: center;
          transform: scale(0.9);
        }
        .shop-image{
          display: flex;
          justify-content: center;
        }
      }
    }
  }
}
</style>
